import { ONE_TO_MANY_PRODUCT, ONE_TO_ONE_PRODUCT } from 'constants/products.js';
import { SHORT_CODE_TO_LOCALE } from 'constants/locales.js';

export const getComponentName = (selectedProduct) => {
  switch (selectedProduct) {
    case ONE_TO_MANY_PRODUCT:
      return 'player';
    case ONE_TO_ONE_PRODUCT:
      return 'callsWidget';
    default:
      return null;
  }
};

/**
 * Checks if a given locale is valid.
 *
 * @param {string} locale - The locale to check.
 * @returns {boolean} - Returns true if the locale is valid, false otherwise.
 */
export const isValidLocale = (locale) => {
  try {
    new Intl.DateTimeFormat(locale);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Fetches the language name of a locale in the provided language
 *
 * @param {string} locale - The desired locale to get language for
 * @param {string} inLocale - The locale in which the language name should be displayed
 * @returns {string} - Returns the display name for a locale for example English
 */
export const getLanguageDisplayName = (locale, inLocale) => {
  try {
    const languageCode = new Intl.Locale(locale).language;
    const languageNames = new Intl.DisplayNames([inLocale || languageCode], {
      type: 'language',
    });
    return languageNames.of(languageCode);
  } catch (e) {
    return locale;
  }
};

/**
 * Fetches the language code for a locale
 *
 * @param {string} locale - The desired locale to get language code for en-US
 * @returns {string} - Returns the language code for a locale for example en
 */
export const getLanguageCodeFromLocale = (locale = '') => {
  try {
    return new Intl.Locale(locale).language;
  } catch (e) {
    return locale.split('-', 1)[0];
  }
};

// Look up if we have any valid locale in the correct format for shortcode language definitions, 'sv' should send 'sv-SE' back etc.
export const shortcodeToLocale = locale => locale && typeof locale === 'string' ? SHORT_CODE_TO_LOCALE[locale.toLowerCase()] : undefined;

/**
 * Returns the suffix of a translation key for a count: 'Singular' for one,
 * 'Plural' for any other count.
 * @param {number} count
 * @returns {'Singular' | 'Plural'}
 */
export const countSuffix = (count) => (count === 1 ? 'Singular' : 'Plural');
